import type { Doc } from '../hooks/useUploadReducer.ts';
import type { OneDriveFileType } from '../services/OneDriveAPIs/OneDriveTypes.ts';
import type { GoogleDrivePickerDoc } from '../services/GoogleAPIs/GoogleDrivePicker.ts';

//TODO: create one common file type
export const isBulkUpload = (
	documents: (File | Doc | null | OneDriveFileType | GoogleDrivePickerDoc)[],
): boolean => documents.length > 1;
